import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { componentInvariants } from 'bloko/common/helpers/customPropTypes';
import 'bloko/blocks/button/button.less';

export default function ButtonGroup({ Element, children, stretched, ...buttonGroupProps }) {
    const className = classnames('bloko-button-group', {
        'bloko-button-group_stretched': stretched,
    });
    return (
        <Element className={className} {...buttonGroupProps}>
            {children}
        </Element>
    );
}

ButtonGroup.propTypes = {
    /** Содержимое внутри строки*/
    children: PropTypes.node,
    /** Кастомный компонент*/
    Element: componentInvariants(['span', 'div']),
    /** На всю длину */
    stretched: PropTypes.bool,
};

ButtonGroup.defaultProps = {
    Element: 'div',
    stretched: false,
};
